module.exports = parcelRequire.resolve("46wHe");